const ACCENT = "#FF6B35";

export default function EmojiMoviePlayer({ emoji, options, selected, result, timeLeft, onAnswer }) {
  const correct = result?.correct;
  const timerColor = timeLeft > 5 ? ACCENT : "#ff3355";

  if (!emoji && !options?.length) return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "2rem" }}>
      <div style={{ color: ACCENT, fontFamily: "var(--font-body)", fontSize:"var(--fs-md)" }}>Загрузка...</div>
    </div>
  );

  return (
    <div style={{
      display: "flex", flexDirection: "column", alignItems: "center",
      gap: "1rem", padding: "1rem", width: "100%", maxWidth: "400px", margin: "0 auto",
    }}>

      {/* Таймер */}
      <div style={{
        width: "3rem", height: "3rem", borderRadius: "9999px",
        background: timerColor,
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize:"var(--fs-xl)", fontWeight: "bold", color: "#fff",
        boxShadow: `0 0 14px ${timerColor}`, transition: "background 0.3s",
      }}>
        {timeLeft}
      </div>

      {/* Эмодзи */}
      <div style={{
        fontSize: "3rem", textAlign: "center", letterSpacing: "0.3rem",
        background: "#111", border: `2px solid ${ACCENT}`, borderRadius: "1.2rem",
        padding: "1rem 1.5rem", width: "100%",
        boxShadow: `0 0 20px ${ACCENT}44`,
      }}>
        {emoji}
      </div>

      {/* Варианты ответов */}
      <div style={{ display: "flex", flexDirection: "column", gap:"var(--gap-md)", width: "100%" }}>
        {options.map((opt, i) => {
          const isCorrect = result && i === correct;
          const isWrongSelected = result && i === selected && i !== correct;
          const isSelected = !result && selected === i;

          let bg = "#1a1a1a";
          let border = `2px solid ${ACCENT}44`;
          let color = "#fff";

          if (result) {
            if (isCorrect)      { bg = "#00cc6633"; border = "2px solid #00cc66"; color = "#00cc66"; }
            else if (isWrongSelected) { bg = "#ff335533"; border = "2px solid #ff3355"; color = "#ff3355"; }
            else                { color = "#555"; }
          } else if (isSelected) {
            bg = `${ACCENT}33`; border = `2px solid ${ACCENT}`; color = ACCENT;
          }

          return (
            <button key={i}
              onClick={() => onAnswer(i)}
              disabled={selected !== null || !!result}
              style={{
                background: bg, border, borderRadius: "0.9rem",
                padding:"var(--pad-md)", color,
                fontFamily: "var(--font-heading)", fontSize:"var(--fs-md)",
                width: "100%", textAlign: "center",
                cursor: selected !== null || result ? "default" : "pointer",
                transition: "all 0.2s",
                fontWeight: result && isCorrect ? "bold" : "normal",
                WebkitTapHighlightColor: "transparent", touchAction: "manipulation",
              }}>
              {isCorrect ? "✅ " : isWrongSelected ? "❌ " : ""}{opt}
            </button>
          );
        })}
      </div>

      {selected !== null && !result && (
        <div style={{ color: ACCENT, fontFamily: "var(--font-body)", fontSize:"var(--fs-sm)" }}>
          Ждём других игроков...
        </div>
      )}
    </div>
  );
}
